import {Injectable} from '@angular/core';
import {OfflineNetworkLayersService} from '../offline-network-layers-service/offline-network-layers.service';
import {OfflineDiagramMappersUtilsService} from '../offline-diagram-mappers-utils/offline-diagram-mappers-utils.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class OfflineMapSummaryStatisticsService {

  constructor(private offlineNetworkLayers: OfflineNetworkLayersService,
              private offlineDiagramMappersUtils: OfflineDiagramMappersUtilsService) {
  }

  calculatePeerConnectionsStatusDistribution(peerConnections) {
    return this.calculateConnectionsAndPConsDistribution(peerConnections, 'peerConnection');
  }

  calculateConnectionsStatusDistribution(connections) {
    return this.calculateConnectionsAndPConsDistribution(connections, 'connection');
  }

  private calculateConnectionsAndPConsDistribution(items, connectionType) {
    const selectedLayers = this.offlineNetworkLayers.getSelectedLayers();
    const statusObject = {normal: 0, fault: 0, locked: 0};

    for (const item of items) {
      this.isAtLeastOneLayerHaveIssues(selectedLayers, item, connectionType) ?
        statusObject.fault++ : statusObject.normal++;

      if (_.isEqual(connectionType, 'peerConnection') && item.adminState
        && item.adminState.startsWith('LOCKED')) {
        statusObject.locked++;
      }
    }

    return statusObject;
  }

  private doesConnectionOrPConHaveIssues(item, layerName, connectionType) {
    if (connectionType === 'connection') {
      return this.offlineDiagramMappersUtils.connectionStatusByLayer(item, layerName) !== 'GOOD';
    } else {
      return this.offlineDiagramMappersUtils.peerConnectionStatusByLayer(item, layerName) !== 'GOOD';
    }
  }

  calculateNodesStatusDistribution(nodes) {
    const statusObject = {normal: 0, fault: 0, locked: 0};
    for (const node of nodes) {
      if (node.operState.state === 15) {
        statusObject.normal++;
      } else {
        statusObject.fault++;
      }

      if (node.adminState === 'LOCKED') {
        statusObject.locked++;
      }
    }
    return statusObject;
  }

  private isAtLeastOneLayerHaveIssues(selectedLayers, item, connectionType): boolean {
    return (selectedLayers.topology && this.doesConnectionOrPConHaveIssues(item, 'topology', connectionType)) ||
      (selectedLayers.quality && this.doesConnectionOrPConHaveIssues(item, 'quality', connectionType));
  }
}
